import { CheckCircle2 } from "lucide-react";
import { Stack } from "react-bootstrap";

import { Term } from "../../utils/interfaces";

import ListCard from "../ListSorter/ListCard";
import styles from "./StepSorter.module.css"
import { trimEnd } from "lodash";

type Step4Props = {
  label: string;
  topFive: Array<Term>;
};

const Step4: React.FC<Step4Props> = ({ label, topFive }) => {
  const pluralizedLabel = topFive.length === 1 ? trimEnd(label, 's') : label
  return (
    <div className={styles.step4}>
      <Stack gap={3}>
        <div className={styles.header}>
          <CheckCircle2 />
          <h3>Please Confirm Your Top {topFive.length} {pluralizedLabel}</h3>
        </div>
        <div className={styles.items}>
          {topFive.map((value) => (
            <ListCard key={value.id} selected>
              <h3>{value.term}</h3>
              <p>{value.definition}</p>
            </ListCard>
          ))}
        </div>
      </Stack>
    </div>
  );
};

export default Step4;
